import { render, staticRenderFns } from "./SavingSuccess.vue?vue&type=template&id=02b6bc5a&scoped=true"
import script from "./SavingSuccess.vue?vue&type=script&lang=js"
export * from "./SavingSuccess.vue?vue&type=script&lang=js"
import style0 from "./SavingSuccess.vue?vue&type=style&index=0&id=02b6bc5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b6bc5a",
  null
  
)

export default component.exports